// extracted by mini-css-extract-plugin
export default {"modalOverlay":"OJ-z","modalContent":"PJ-z","header":"QJ-z","close":"RJ-z"};